import { ICellRendererParams } from "@ag-grid-community/core";
import { GenericTableCell } from "gen/model/genericTableCell";
import { GenericTableRow } from "gen/model/genericTableRow";
import React from "react";
import { DataTableContext } from "shared/components/table/data/DataTableContext";
import { DataTableCellRenderer } from "shared/components/table/data/internal/DataTableCellRenderer";
import { DataTableChildCount } from "shared/components/table/data/internal/DataTableChildCount";

export const DataTableHeaderCellRenderer: React.FC<
  ICellRendererParams<GenericTableRow, GenericTableCell, DataTableContext>
> = (props) => (
  <>
    <DataTableCellRenderer {...props} />
    <DataTableChildCount {...props} />
  </>
);
